<div class="modified_tools_container">
  <h1 class="table__title modified_table__title">Search Results</h1>
  
  <ul class="table__control inline-list modified_table_control modified_inline-list">
    <li *ngIf="(userRoles$ | async)?.superUser">
      <button [disabled]="!fullTextResults && !selection || selection.selected.length == 0" mat-raised-button 
      (click)="assignLegalCounsel()">
        <mat-icon><img src="assets/images/icon-assign.svg" /></mat-icon>
        Assign to New Legal Counsel
      </button>
    </li>
    <li>
      <button mat-raised-button (click)="DownloadResults.emit(false)">
        <mat-icon><img src="assets/images/icon-download.svg" /></mat-icon>
        Download
      </button>
    </li>
    <li>
      <button [disabled]="!fullTextResults && !selection || selection.selected.length == 0 || (downloading$ | async)" mat-raised-button
      class="grey-btn" (click)="download()">
      <mat-icon><img src="assets/images/icon-download.svg" /></mat-icon>
      Download Selected Documents
    </button>
    </li>
    <li>
      <section class="custom-slide-group2">
        <mat-slide-toggle class="custom-slide" [(ngModel)]="fullTextResults">Full Text Results</mat-slide-toggle>
      </section>
    </li>
    <li>
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter Results" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </li>
  </ul>
</div>

<div class="download_error">
<div *ngIf="downloadTimedOut" class="alert alert-warning">Unable to download file</div>
</div>

<div class="table__container">
<ng-template #noDocuments>
  <h3>No Results</h3>
</ng-template>

<div class="alert alert-warning">Search results are limited to only those contracts that you have access to
</div>

<div class="alert alert-warning" *ngIf="selection && selection.selected.length > 1">Selecting multiple contracts for
  download may take a long time or even
  time out</div>

<div class="alert alert-warning" *ngIf="resultsExceeded">Number of results exceeded limit, please be more specific. <a
    class="link" (click)="DownloadResults.emit(true)">Download more results</a>
</div>

<ng-container *ngIf="!fullTextResults">
  <table *ngIf="documentIds?.length > 0;else noDocuments" class="table__inner" mat-table [dataSource]="dataSource"
    matSort (matSortChange)="applySort($event)" matSortActive="Name" matSortDirection="asc">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="ContractDeletedDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef align="center">
        Icon
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" align="center">

        <mat-icon><img
            [src]="element?.propertiesObj.ContractDeletedDate ? 'assets/images/icon-invalid.svg' : 'assets/images/icon-file.svg'" />
        </mat-icon>

      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element"><a (click)="closeDialog()" target="_blank"
          [routerLink]="['/',objectStore,'DocumentView',element.id]">
          {{ element?.propertiesObj.DocumentTitle }}</a></td>
    </ng-container>

    <ng-container matColumnDef="ContractIdentifier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract ID
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractIdentifier }}</td>
    </ng-container>

    <ng-container matColumnDef="ContractStartDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract Start Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractStartDate | aspenDate }}</td>
    </ng-container>
    <ng-container matColumnDef="ContractEndDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract End Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractEndDate| aspenDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractDateOfLastSignature">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Signature Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractDateOfLastSignature| aspenDate }}</td>
    </ng-container>
    <ng-container matColumnDef="ContractReviewDeadlineDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Review Deadline Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractReviewDeadlineDate| aspenDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractStatus | asyncChoiceList:objectStore:'ContractStatuses' | async }}</td>
    </ng-container>
    <ng-container matColumnDef="DateCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Date Loaded
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.DateCreated| aspenDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractLibrary">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Library
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element">{{ element?.propertiesObj.LibraryFolder }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractCategory">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Category
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element">{{ element?.propertiesObj.CategoryFolder }}
      </td>
    </ng-container>
    <ng-container matColumnDef="LinkedDocuments">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Linked Documents
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        <span *ngFor="let lnk of element?.linkedDocuments;let last = last">
          <ng-container *ngIf="linkedDocuments$ | async as linked">
            {{linked[lnk]}} {{last ? '': ','}}
          </ng-container>
        </span>

      </td>
    </ng-container>
    <ng-container matColumnDef="Creator">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Creator
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.Creator }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractAgreementType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Type of Agreement
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractAgreementType | asyncChoiceList:objectStore:'ContractAgreementTypes' | async }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractBusinessOwner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Business Owner
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ (element?.propertiesObj.ContractBusinessOwner | asyncBusinessOwnerEntity | async)?.fullname }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractCMSID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        CMS ID
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractCMSID }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</ng-container>

<ng-container *ngIf="fullTextResults">
  <table *ngIf="documentIds?.length > 0;else noDocuments" class="table__inner" mat-table [dataSource]="dataSource"
    matSort (matSortChange)="applySort($event)">

    <ng-container matColumnDef="Summary">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Summary
      </th>
      <td mat-cell *matCellDef="let element">
        <!-- {{ element | json }} -->
        <div [innerHTML]="getSummaryData(element.id)"></div>
        <hr>
        <span>
          <b>Contract Identifier:</b> {{element?.propertiesObj?.ContractIdentifier}}
          &nbsp;<b>Contract Name:</b> <a (click)="closeDialog()" target="_blank"
            [routerLink]="['/',objectStore,'DocumentView',element.id]">
            {{ element?.propertiesObj.DocumentTitle }}</a>
          &nbsp;<b>Contract Start Date:</b> {{element?.propertiesObj?.ContractStartDate | aspenDate}}
          &nbsp;<b>Contract End Date:</b> {{element?.propertiesObj?.ContractEndDate | aspenDate}}
          &nbsp;<b>Signature Date:</b> {{element?.propertiesObj?.ContractDateOfLastSignature | aspenDate}}
          &nbsp;<b>Review Deadline Date:</b> {{element?.propertiesObj?.ContractReviewDeadlineDate | aspenDate }}
          &nbsp;<b>Status:</b>
          {{ element?.propertiesObj.ContractStatus | asyncChoiceList:objectStore:'ContractStatuses' | async }}
          &nbsp;<b>CMS ID:</b> {{element?.propertiesObj?.ContractCMSID}}
          &nbsp;<b>Location:</b> {{element?.propertiesObj?.FoldersFiledIn}}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['Summary'];sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['Summary']" (click)="preview(row)"></tr>
  </table>
</ng-container>

</div>

<mat-paginator [ngStyle]="{'display':documentIds?.length > 0 ? '':'none'}" class="table__pagination"
[pageSizeOptions]="[5, 10, 25, 100]" (page)="paged($event)">
</mat-paginator>
